import {
  isRequestFeedbackType,
  isRequestPostType,
  isWelcomePostType,
} from '../../Newsboard.utils'

import { NewsboardPostTypeFooter } from './NewsboardPostTypeFooter'
import { NewsboardRequestTypeFooter } from './NewsboardRequestTypeFooter'
import { NewsboardWelcomePostFooter } from './NewsboardWelcomePostFooter'
import { Skeleton } from './Skeleton'

import * as styles from './NewsboardPostFooter.module.css'

function NewsboardPostFooter({ data, loading, ref, ...restProps }) {
  return (
    <div className={styles.NewsboardPostFooter} ref={ref}>
      {loading ? (
        <Skeleton />
      ) : isRequestPostType(data) || isRequestFeedbackType(data) ? (
        <NewsboardRequestTypeFooter {...restProps} data={data} />
      ) : isWelcomePostType(data) ? (
        <NewsboardWelcomePostFooter {...restProps} data={data} />
      ) : (
        <NewsboardPostTypeFooter {...restProps} data={data} />
      )}
    </div>
  )
}

export default NewsboardPostFooter
